"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));

var _react = _interopRequireDefault(require("react"));

var _idbReactTranslations = _interopRequireDefault(require("@identitybuilding/idb-react-translations"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var CurrentOffersLightbox = /*#__PURE__*/function (_React$Component) {
  _inherits(CurrentOffersLightbox, _React$Component);

  var _super = _createSuper(CurrentOffersLightbox);

  function CurrentOffersLightbox(props) {
    var _this;

    _classCallCheck(this, CurrentOffersLightbox);

    _this = _super.call(this, props);
    _this.state = {};
    _this.keyDownHandler = _this.keyDownHandler.bind(_assertThisInitialized(_this));

    _this.translate = function (e) {
      return (0, _idbReactTranslations["default"])(e, props.lang);
    };

    return _this;
  }

  _createClass(CurrentOffersLightbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("keydown", this.keyDownHandler); // Setup event listeners
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keydown", this.keyDownHandler); // Remove event listeners
    } // Fired when typing <- or -> arrow or escape key

  }, {
    key: "keyDownHandler",
    value: function keyDownHandler(e) {
      if (e.keyCode === 27) {
        this.props.closeLightbox();
      }

      if (typeof this.props.index === "number") {
        if (e.keyCode === 37) {
          this.props.lightboxHandler(this.props.index, "prev");
        } else if (e.keyCode === 39) {
          this.props.lightboxHandler(this.props.index, "next");
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var imageClass = document.getElementsByClassName('coImage')[this.props.index];
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "lightboxWrapper",
        tabIndex: "0"
      }, /*#__PURE__*/_react["default"].createElement("figure", {
        className: "lb ".concat(imageClass.naturalHeight > imageClass.naturalWidth ? 'portrait' : 'landscape')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        onClick: function onClick() {
          return _this2.props.lightboxHandler(_this2.props.index, 'prev');
        },
        className: "lbArrow"
      }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
        animated: true,
        name: "ArrowLeft"
      })), /*#__PURE__*/_react["default"].createElement("img", {
        onClick: function onClick() {
          return _this2.props.closeLightbox();
        },
        src: this.props.result.image,
        alt: this.props.result.title
      }), /*#__PURE__*/_react["default"].createElement("div", {
        onClick: function onClick() {
          return _this2.props.lightboxHandler(_this2.props.index, 'next');
        },
        className: "lbArrow lbNext"
      }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
        animated: true,
        name: "ArrowRight"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "lbClose",
        onClick: function onClick() {
          return _this2.props.closeLightbox();
        }
      }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
        name: "Close"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "lbCount"
      }, this.props.index + 1, " ", this.translate("of_the").toLowerCase(), " ", this.props.results.length)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "lbBg",
        onClick: function onClick() {
          return _this2.props.closeLightbox();
        }
      }));
    }
  }]);

  return CurrentOffersLightbox;
}(_react["default"].Component);

exports["default"] = CurrentOffersLightbox;